<template>
  <div class="chart time-chart-wrap">
    <div class="grow shrink overflow-hidden">
      <ScopedLoading v-if="gettingFrequency"></ScopedLoading>
      <PortionChart class="portion-chart"></PortionChart>
    </div>
    <OverviewChart class="grow-0 shrink-0 h-[60px] overflow-hidden"></OverviewChart>
  </div>
</template>

<script setup>
import PortionChart from './portion.vue';
import OverviewChart from './overview.vue';
import { activityDetailStore } from '@client/store/activityDetailStore';
import { computed } from 'vue';
import ScopedLoading from '../../../components/ScopedLoading.vue';
const activityDetailStoreRef = activityDetailStore();

const gettingFrequency = computed(() => activityDetailStoreRef.gettingFrequency);
</script>

<style lang="scss" scoped>
.chart {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .portion-chart {
    height: 100%;
  }
}
</style>
